import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { providerList } from "../../../../../../../services/tasyProvider.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const ProviderExternalId = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(providerList);

  const [options, setOptions] = useState<ISelectType[]>([]);
  const [searchBy, setSearchBy] = useState<string>("");

  const fetchOptions = useCallback(async () => {
    if (!searchBy || searchBy.trim() === "" || searchBy.length < 3) return;
    const { data, success } = await sendRequest({ SearchBy: searchBy, EnableCode: true });
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.providerName ?? "",
        })),
      );
    }
  }, [sendRequest, searchBy]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  const handleSetSearchBy = useCallback((search: string) => {
    setSearchBy(search);
  }, []);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="providerExternalId"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "provider_external_id")}
        SearchAsYouTypeParams={handleSetSearchBy}
      />
    </Grid>
  );
});
